/**
 * 接口统一集成模块
 */
// import * as login from './modules/login'  // 登录模块

import * as menu from './modules/menu'
import * as user from './modules/user'
import * as match from './modules/match'
import * as battle from './modules/battle'
import * as join from './modules/join'
import * as high from './modules/high'
import * as jlp from './modules/jlp'
import * as ddk from './modules/ddk'
import * as examin from './modules/examin'
import * as projectCenter from './modules/projectCenter'
import * as district from './modules/district'

// 默认全部导出
export default {
  menu,
  user,
  match,
  battle,
  join,
  high,
  jlp,
  ddk,
  examin,
  projectCenter,
  district
}



// WEBPACK FOOTER //
// ./src/comm/http/api.js